import { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

export type FaqItem = { q: string; a: ReactNode };

/**
 * Server-render-friendly FAQ, rendered as flat children of #mv-content:
 * an H2, an optional lead paragraph, then one native <details> per
 * question with the question as an H3 inside <summary>. Every answer is
 * in the server-rendered HTML and crawlable, and the toggle needs no
 * JavaScript. Styling comes from the .content-block rules in styles.css.
 *
 * We deliberately do NOT emit FAQPage JSON-LD: Google stopped showing FAQ
 * rich results for general sites, so the structured data is no longer a
 * priority. The questions and answers live as ordinary on-page content.
 */
export function FaqSection({
  items,
  heading = "Frequently Asked Questions",
  description,
}: {
  items: FaqItem[];
  heading?: string;
  description?: ReactNode;
}) {
  return (
    <>
      <h2>{heading}</h2>
      {description && <p>{description}</p>}
      {items.map((item, i) => (
        <details key={i}>
          <summary>
            <h3>{item.q}</h3>
            <ChevronDown className="h-4 w-4" aria-hidden />
          </summary>
          {typeof item.a === "string" ? <p>{item.a}</p> : <div>{item.a}</div>}
        </details>
      ))}
    </>
  );
}
